// first: it must run before the stores issue their Preferences calls
import './capacitor-logging.js';

import { createApp } from 'vue';
import { createSentryMonitor } from './sentry';
import { createAmplitudeMonitor } from './amplitude';

import App from './App.vue';
import store from './store';
import router from './router';
import locale, { initLocale } from './locale';

import Icon from './components/icon';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

import './main.css';

// app
const app = createApp(App);

// plugins
app.use(store);
app.use(router);
app.use(locale);

// Initialize locale after store is ready
initLocale();

// components
app.component('Icon', Icon);

// mount app
app.mount('#app');

// Notify Capgo that it is ready to receive updates
CapacitorUpdater.notifyAppReady();

// monitors
if (import.meta.env.VITE_ENVIRONMENT === 'PROD') {
	createSentryMonitor(app, router);
	createAmplitudeMonitor();
}

// supress all capacitor UNIMPLEMENTED plugin uncaught errors
window.addEventListener('unhandledrejection', function (event) {
	if (event.reason.code === 'UNIMPLEMENTED') {
		event.preventDefault();
	}
});
